module.exports = __webpack_public_path__ + "src/resources/standard_task_40px.png";